<template>
  <div class="login">
    <div class=" main-container d-flex flex-column">
      <nav class="navbar navbar-toggleable-md bg-theme nopadding-y">
        <div class=" nopadding-y">
          <a class="navbar-brand nopadding-y" href="#">
            <img src="../../../static/img/new-Logo-color.png" style="width: 150px;">
          </a>
        </div>
      </nav>
        <div class="container-login">
          <div class="form-container">
            <!-- Login Form -->
            <div v-if="!showForgotPassword">
                <span class="full-width d-inline-block text-center"
                  style="font-size: 20px; font-weight: 600; margin-bottom: 20px">Login with your account</span>

                <!-- Company display if selected and no email error -->
                <div class="label-box-container" v-if="selectedCompany && !emailError" @click="changeCompany">
                  <span class="company-name">{{ selectedCompany.companyName }}</span>
                </div>

              <form v-on:submit.prevent="handleNextClick" novalidate="true">
                <!-- Email field -->
                <div class="form-group margin-base-y" style="position: relative;">
                  <label for="email" class="control-label">Enter your email:</label>
                  <div class="input-container">
                    <input type="email" id="email" class="form-control input-field"
                      placeholder="Enter your email" v-on:input="handleEmailChange" v-on:keyup.enter="handleNextClick" v-model="email" :disabled="showPasswordField">
                    <div class="input-icon" v-if="emailValidating && email.length > 0">
                      <div class="spinner-border spinner-border-sm text-primary" role="status">
                        <span class="sr-only">Loading...</span>
                      </div>
                    </div>
                    <div class="input-icon" v-else-if="emailValidated">
                      <i class="fa fa-check-circle mail-checked"></i>
                    </div>
                  </div>
                  <div class="text-danger" v-if="emailError" style="position: absolute">{{emailError}}</div>
                </div>

                <!-- Next button when password field is not shown -->
                <div class="form-group" v-if="!showPasswordField">
                  <button type="submit" class="next-button" :disabled="nextButtonDisabled">
                    <span>Next</span>
                  </button>
                </div>
              </form>
              <form v-on:submit.prevent="handleLogin" novalidate="true" v-if="showPasswordField">
                <!-- Password field -->
                <div class="form-group margin-base-y" style="position: relative;">
                  <label for="password" class="control-label">Enter your password:</label>
                  <div class="input-container">
                    <input :type="showPassword ? 'text' : 'password'" id="password"
                      class="form-control input-field" placeholder="Enter your password"
                      v-on:input="handlePasswordChange" v-on:keyup.enter="handleLogin" v-model="password" :disabled="!emailValidated">
                    <div class="input-icon password-toggle" @click="showPassword = !showPassword" v-if="emailValidated">
                      <i :class="showPassword ? 'fa fa-eye-slash' : 'fa fa-eye'"></i>
                    </div>
                  </div>
                  <div class="text-danger" v-if="passwordError" style="position: absolute ">{{passwordError}}</div>
                </div>

                <!-- Forgot Password Link -->
                <div class="forget-password">
                  <span @click.prevent="showForgotPassword = true">
                    Forgot Password?
                  </span>
                </div>

                <!-- Login button -->
                <div class="form-group">
                  <button type="submit" class="login-button" :disabled="loginButtonDisabled">
                    <img src="static/img/loader.gif" v-if="loginLoading" class="next-arrow">
                    <span v-else>Login</span>
                  </button>
                </div>
              </form>
            </div>

            <!-- Forgot Password Component -->
            <ForgotPassword v-if="showForgotPassword" @back-to-login="handleBackToLogin" />
          </div>
        </div>
      <!-- </div> -->
      <footer
        style="background-color: #01271F; text-align: right; padding: 18px 0; position: fixed; bottom: 0; width: 100%;">
        <span style="color: white; cursor: pointer; font-size: 12px; padding-right: 80px; font-weight: 600;"
          @click="isBugModalOpen = true">
          Report A Bug
        </span>
      </footer>

      <!-- Company selection modal using ReuseableModal -->
      <ReuseableModal 
        :modelValue="isCompanyModalOpen" 
        @update:modelValue="isCompanyModalOpen = $event"
        title="Select your company" 
        submitButtonText="Confirm" 
        @submit="confirmCompanySelection">
        <div class="form-group">
          <label for="company-select">Select Company</label>
          <select 
            id="company-select" 
            class="form-control" style="height: 40px;"
            v-model="selectedCompanyId">
            <option 
              v-for="company in companies" 
              :key="company.id || company.companyName" 
              :value="company.id || company.companyName">
              {{ company.companyName }}
            </option>
          </select>
        </div>
      </ReuseableModal>

      <BugReportModal :fullOverlay="true" :isOpen="isBugModalOpen" @update:isOpen="isBugModalOpen = $event" />
    </div>
  </div>
</template>

<script>
import firebaseLib from "firebase";
import "firebase/database";
import api from "../../assets/config/api";
import firebase from "../../assets/config/firebase";
import sw from "sweetalert";
import _ from "lodash";
import ForgotPassword from "./ForgotPassword.vue";
import ReuseableModal from "../UIComponents/ReuseableModal.vue";
import BugReportModal from "../UIComponents/BugReportModal.vue";
import CustomDropdown from "../UIComponents/CustomDropdown.vue";
import helpers from "../../assets/config/helpers";

export default {
  components: {
    ForgotPassword,
    ReuseableModal,
    CustomDropdown,
    BugReportModal
  },
  data() {
    return {
      activeNotifications: false,
      email: "",
      password: "",
      emailError: "",
      passwordError: "",
      isLoading: false,
      loginLoading: false,
      emailValidating: false,
      selectedCompany: null,
      companies: [],
      emailValidated: false,
      showPassword: false,
      showForgotPassword: false,
      isCompanyModalOpen: false,
      selectedCompanyId: "",
      isBugModalOpen: false,
    };
  },
  computed: {
    loginButtonDisabled() {
      return this.loginLoading || !this.emailValidated || !this.password;
    },
    nextButtonDisabled() {
      return this.emailValidating || !this.email;
    }
  },
  methods: {
    handleBackToLogin() {
      this.showForgotPassword = false;
      this.passwordError = "";
      this.emailError = "";
      this.showPasswordField= false;
      this.emailValidated= false,
      this.email= ""
      this.selectedCompany= null
    },
    handleEmailChange() {      // Clear previous errors and state, no validation here
      this.emailError = "";
      this.emailValidated = false;
      this.showPasswordField = false;
      this.password = "";
      this.passwordError = "";
      this.selectedCompany = null;
      this.companies = [];
    },

    async handleNextClick() {
      if (!this.email) {
        this.emailError = "Email is required";
        return;
      }

      const { emailRegex } = helpers;
      if (!emailRegex.test(this.email)) {
        this.emailError = "Please enter a valid email address";
        return;
      }

      const atIndex = this.email.indexOf('@');
      if (atIndex === -1 || !this.email.slice(atIndex + 1).includes('.')) {
        this.emailError = "Please enter a valid email address";
        return;
      }

      // Step 2: Email is valid, proceed to company lookup
        this.emailValidating = true;
        try {
          const response = await this.findCompany();
          if (!this.email) {
            return;
          }

          if (response && Array.isArray(response) && response.length > 0) {
            localStorage.setItem('firebaseConfig', JSON.stringify(response[0].firebase || {})); 
            this.companies = response;
            this.selectCompany(response[0]);
            this.emailValidated = true;
            this.emailError = ""
            this.showPasswordField = true;

            if (response.length > 1) {
              this.selectedCompanyId = response[0].id || response[0].companyName;
              this.openCompanyModal();
            }
          } else {
            this.emailError = "You are not associated with any company";
          }
        } catch (e) {
        this.emailError = "You are not associated with any company";
        } finally {
          this.emailValidating = false;
        }
    },

    handlePasswordChange() {
      this.passwordError = "";
    },

    async handleLogin(e) {
      e.preventDefault();

      try {
        if (!this.email) {
          throw { message: "Email is required!" };
        }
        if (!this.emailValidated) {
          this.emailError = "Please validate your email first";
          return;
        }
        if (!this.password) {
          throw { message: "Password is required!" };
        }
        if (this.password.length < 6) {
          throw { message: "Password must be at least 6 characters long" };
        }
        await this.login();
      } catch (e) {
        this.passwordError = e.message;
      }
    },

    async login() {
      const credentials = { email: this.email, password: this.password };
      const users = [];

      try {
        this.loginLoading = true;

        const response = await firebase.login(credentials);
        response.data.isActive = response.data.isActive || false;
        if (!response.data.isActive) {
          swal("Account Inactive", "Your account is not active. Please contact your administrator.", "error");
          this.loginLoading = false;
          return;
           }
        console.log("response", response.data.isActive);
        const [allUsersResponse, constants, allLeaves] = await Promise.all([
          firebase.readDatabase("/users"),
          firebase.readDatabase("/constants"),
          firebase.readDatabase("/leaves"),
        ]);

        for (const user in allUsersResponse.data) {
          users.push({ ...allUsersResponse.data[user], uid: user });
        }

        this.loginLoading = false;

        this.$store.commit("setUser", {
          uid: response.key,
          ...response.data
        });

        this.$store.commit("setAllUsers", users);
        this.$store.commit("setConstants", constants.data);
        this.$store.commit("setCompany", this.selectedCompany);
        this.$store.commit("setAllLeaves", allLeaves.data);
        await this.$store.dispatch('fetchAllTrelloData');

        this.fetchAllUsersRealTime();
        this.fetchLeavesRealTime();
        this.fetchUserLeavesRealTime();
        this.fetchConstantsRealTime();
        this.fetchNewUsersRealTime();
        this.removeUserRealTime();
        console.log("before route")

        this.$router.replace("/overview");
        console.log("after route")

      } catch (e) {
        this.passwordError = e.message;
        this.loginLoading = false;
      } finally {
        localStorage.removeItem('firebaseConfig');
      }
    },

    async selectCompany(company) {
      this.selectedCompany = company;

      try {
        if (firebase.checkAlreadyConfiguredApp()) {
          await firebase.unconfigureFirebase();
        }

        await firebase.configureFirebase(company.firebase);
      } catch (e) {
        sw("Error!", e.message, "error");
      }
    },

    confirmCompanySelection() {
      const selectedCompany = this.companies.find(
        company => (company.id || company.companyName) === this.selectedCompanyId
      );

      if (selectedCompany) {
        this.selectCompany(selectedCompany);
      }

      this.closeCompanyModal();
    },

    async findCompany(emailToFind) {
      try {
        const emailToCheck = emailToFind || this.email.toLowerCase();
        const response = await api.findCompanyByEmail(emailToCheck);
        return response;
      } catch (e) {
        console.error('findCompanyByEmail error:', e);
        throw e;
      }
    },

    changeEmail() {
      this.selectedCompany = null;
      this.email = "";
      this.password = "";
      this.companies = [];
      this.showPasswordField = false;
      this.emailValidated = false;
    },

    changeCompany() {
      if (this.selectedCompany) {
        this.selectedCompanyId = this.selectedCompany.id || this.selectedCompany.companyName;
      }
      this.openCompanyModal();
    },

    openCompanyModal() {
      this.isCompanyModalOpen = true;
    },

    closeCompanyModal() {
      this.isCompanyModalOpen = false;
    },

    fetchNewUsersRealTime() {
      firebaseLib
        .database()
        .ref("users")
        .on("child_added", data => {
          if (data.val()) {
            const allUsers = this.$store.state.auth.allUsers;
            const foundUser = _.find(allUsers, { uid: data.key });
            if (!foundUser) {
              this.$store.commit("setAllUsers", [...allUsers, { ...data.val(), uid: data.key }]);
            }
          }
        });
    },

    removeUserRealTime() {
      const allUsers = this.$store.state.auth.allUsers;

      firebaseLib
        .database()
        .ref("users")
        .on("child_removed", data => {
          if (data.val()) {
            const foundIndex = _.findIndex(allUsers, { uid: data.key });
            if (foundIndex > -1) {
              allUsers.splice(foundIndex, 1);
              this.$store.commit("setAllUsers", allUsers);
            }
          }
        });
    },

    fetchAllUsersRealTime() {
      firebaseLib
        .database()
        .ref("users")
        .on("child_changed", data => {
          if (data.val()) {
            const allUsers = this.$store.state.auth.allUsers;
            const targetIndex = _.findIndex(allUsers, { uid: data.key });
            allUsers[targetIndex] = data.val();
            this.$store.commit("setAllUsers", allUsers);
          }
        });
    },

    fetchConstantsRealTime() {
      const constants = this.$store.state.auth.constants || {};

      firebaseLib
        .database()
        .ref("constants")
        .on("child_changed", data => {
          if (data.val()) {
            constants[data.key] = data.val();
            this.$store.commit(s, constants);
          }
        });
    },

    fetchLeavesRealTime() {
      firebaseLib
        .database()
        .ref("leaves")
        .orderByChild("createdAt")
        .on(
          "value",
          (snapshot) => {
            const leaves = [];
            snapshot.forEach((childSnapshot) => {
              const leave = childSnapshot.val();
              leave.id = childSnapshot.key;
              leaves.push(leave);
            });

            const sortedLeaves = leaves.reverse();
            this.$store.commit("setAllLeaves", sortedLeaves);
          },
          (error) => {
            console.error("Error fetching real-time leaves: ", error);
          }
        );
    },

    fetchUserLeavesRealTime() {
      const user = this.$store.state.auth.user;

      if (!user) {
        console.error("User not found!");
        return;
      }

      firebaseLib
        .database()
        .ref("leaves")
        .orderByChild("userId")
        .equalTo(user.uid)
        .on("value", (snapshot) => {
          const leaves = [];
          snapshot.forEach((childSnapshot) => {
            const leave = childSnapshot.val();
            leave.id = childSnapshot.key;
            leaves.push(leave);
          });
          const sortedLeaves = leaves.sort((a, b) => b.createdAt - a.createdAt);
          this.$store.commit("setUserLeaves", sortedLeaves);
        }, (error) => {
          console.error("Error fetching real-time leaves: ", error);
        });
    }
  }
};
</script>

<style scoped>
</style>


// WEBPACK FOOTER //
// src/components/Login/Login.vue